import {DashboardCard} from '../dashboard-card/DashboardCard'
import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {useParsedSearchParams} from '@/hooks/useParsedSearchParams'
import {DashboardSearchParams} from '../../types'
import {useGetDashboardOps} from '../../query/useGetDashboardOps'
import {useMemo} from 'react'
import {DashboardSimpleCardSkeleton} from '../dashboard-simple-card-skeleton/DashboardSimpleCardSkeleton'
import {formatNumber} from '@/utilities/helpers'

export const DashboardTherapistAbsencesCard = () => {
    const {t} = useTranslation()
    const {searchParams} = useParsedSearchParams(DashboardSearchParams)
    const {data, isLoading} = useGetDashboardOps({
        fields: ['consultantAbsences'],
        ...searchParams
    })

    const total = useMemo(
        () =>
            (data?.consultantAbsences?.therapist?.absences ?? 0) + (data?.consultantAbsences?.therapist?.permits ?? 0),
        [data?.consultantAbsences]
    )

    if (isLoading) {
        return <DashboardSimpleCardSkeleton title={t('dashboard:therapist_absences')} />
    }

    return (
        <DashboardCard title={t('dashboard:therapist_absences')}>
            <Flexbox direction="column" gap={4}>
                <Text palette="neutral" shade="900" size="displaySm" weight={700}>
                    {formatNumber(total)}
                </Text>

                <ul>
                    <li>
                        <Flexbox align="center" gap={1}>
                            <Text palette="neutral" shade="900" size="textSm" weight={600}>
                                {formatNumber(data?.consultantAbsences?.therapist?.absences ?? 0)}
                            </Text>
                            <Text palette="neutral" shade="600" size="textSm" weight={400}>
                                {t('dashboard:absences_label')}
                            </Text>
                        </Flexbox>
                    </li>
                    <li>
                        <Flexbox align="center" gap={1}>
                            <Text palette="neutral" shade="900" size="textSm" weight={600}>
                                {formatNumber(data?.consultantAbsences?.therapist?.permits ?? 0)}
                            </Text>
                            <Text palette="neutral" shade="600" size="textSm" weight={400}>
                                {t('dashboard:permits_label')}
                            </Text>
                        </Flexbox>
                    </li>
                </ul>
            </Flexbox>
        </DashboardCard>
    )
}
